import { Box, FormControl, FormHelperText, Typography } from "@mui/material";
import PropTypes from "prop-types";
import { convertToDefEventPara } from "../helper.js";

const ACCENT = "#4A78BC";

/**
 * SegmentedInput — the click dummy's `seg()`: a label above a row of pill
 * buttons. Drop-in replacement for boolean switches (`boolean: true` →
 * nein/ja) and small static `select`s (uses `item.options`). Writes the same
 * value shape as the control it replaces.
 */
export default function SegmentedInput(props) {
  const {
    item,
    value,
    onChange,
    error,
    showErrorText = false,
    disabled = false,
  } = props;

  const boolean = item.boolean === true;
  const options = boolean
    ? [
        { key: false, label: "nein" },
        { key: true, label: "ja" },
      ]
    : (item.options || []).map((o) =>
        typeof o === "string" ? { key: o, label: o } : o
      );

  const isActive = (key) => (boolean ? Boolean(value) === key : value === key);

  let helperText = "";
  if (showErrorText) helperText = error;
  else if (item.help) helperText = item.help;

  return (
    <FormControl {...(error && { error: true })} sx={{ width: "100%" }}>
      {item.label && (
        <Typography
          sx={{
            fontSize: "12.5px",
            fontWeight: 600,
            color: "#374151",
            mb: "9px",
          }}
        >
          {item.label}
        </Typography>
      )}
      <Box sx={{ display: "flex", gap: "8px", flexWrap: "wrap" }}>
        {options.map((o) => {
          const active = isActive(o.key);
          return (
            <Box
              key={String(o.key)}
              component="button"
              type="button"
              disabled={disabled}
              onClick={() =>
                !disabled && onChange(convertToDefEventPara(item.name, o.key))
              }
              sx={{
                px: "15px",
                py: "9px",
                borderRadius: "9px",
                fontSize: "13.5px",
                fontWeight: active ? 600 : 500,
                fontFamily: "inherit",
                cursor: disabled ? "default" : "pointer",
                border: `1.5px solid ${active ? ACCENT : "#dde3ec"}`,
                backgroundColor: active ? "#EEF3FB" : "#fff",
                color: active ? "#3A6099" : "#6b7280",
              }}
            >
              {o.label}
            </Box>
          );
        })}
      </Box>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
}

SegmentedInput.propTypes = {
  item: PropTypes.object.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
  showErrorText: PropTypes.bool,
  disabled: PropTypes.bool,
};
